import React from 'react';
import PropTypes from 'prop-types';

export default class SlickArrow extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string,
        style: PropTypes.object,
        onClick: PropTypes.func,
        key: PropTypes.string,
        'data-role': PropTypes.string
    };

    render() {
        const classProps = {
            style: this.props.style,
            className: this.props.className,
            onClick: this.props.onClick,
            key: this.props.key,
            'data-role': this.props['data-role']
        };
        return (
            <div {...classProps}>
                <div role="button" className="slick-control">
                    <i className="icon-arrow" />
                </div>
            </div>
        );
    }
}
